import styled, { css } from 'styled-components'
import { TooltipTextWrapperProps } from './types'
import { FontStyle } from '.././../Core/Typography/Font/Font.styles'

export const TooltipTextWrapper = styled('div') <TooltipTextWrapperProps>`
  visibility: hidden;
  min-width: 120px;
  max-width: 300px;
  background-color: var(--tooltip-bg, ${props => props.theme?.tooltip?.background || props.theme.colors.main.dark});
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 9999;
  top: 165%;
  left: 50%;
  cursor: ${props => (props?.onClick ? 'pointer' : 'default')};
  transform: ${props =>
    `translate(${props.translateX ? `${props.translateX}px` : '-50%'}, ${props.translateY ? `${props.translateY}px` : '0px'
    })`};
  border: 1px solid ${props => props.theme.colors.shades.neutral[0]};
  text-align: left;
  padding: 8px;
  color: var(--tooltip-text, ${props => props.theme?.tooltip?.text || props.theme.colors.main.blank});
  &:before {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-45%);
    border: 10px solid transparent;
    border-bottom-color: var(--tooltip-border, ${props => props.theme?.tooltip?.border || props.theme.colors.shades.neutral[0]});
  }
  &:after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50.9%;
    transform: translateX(-50%);
    border: 9px solid transparent;
    border-bottom-color: var(--tooltip-bg, ${props => props.theme?.tooltip?.background || props.theme.colors.main.dark});
  }

  ${props =>
    props.width &&
    css`
      width: ${props.width};
      min-width: unset;
      max-width: unset;
    `}
  
  ${props =>
    props.position === 'top' &&
    css`
      top: unset;
      bottom: 125%;
      &:before {
        top: 100%;
        bottom: unset;
        border-bottom-color: transparent;
        border-top-color: var(--tooltip-border, ${props => props.theme?.tooltip?.border || props.theme.colors.shades.neutral[0]});
      }

      &:after {
        top: 100%;
        bottom: unset;
        border-bottom-color: transparent;
        border-top-color: var(--tooltip-bg, ${props => props.theme?.tooltip?.background || props.theme.colors.main.dark});
      }
    `}

  ${props =>
    props.position === 'left' &&
    css`
      right: 130%;
      left: unset;
      ${props.largeContent
        ? css`
            top: 50%;
          `
        : css`
            top: 0;
          `}

      transform: translateX(${props.translateX ? `${props.translateX}px` : '8px'}) translateY(${props.translateY ? `${props.translateY}px` : '0px'});

      &:before {
        top: 50%;
        bottom: unset;
        left: calc(100% + 1px);
        transform: translateY(-50%);
        border-bottom-color: transparent;
        border-left-color: var(--tooltip-border, ${props => props.theme?.tooltip?.border || props.theme.colors.shades.neutral[0]});
      }

      &:after {
        top: 50%;
        bottom: unset;
        left: 100%;
        transform: translateY(-50%);
        border-bottom-color: transparent;
        border-left-color: var(--tooltip-bg, ${props => props.theme?.tooltip?.background || props.theme.colors.main.dark});
      }
    `}

  ${props =>
    props.position === 'right' &&
    css`
      left: 113%;

      ${props.largeContent
        ? css`
            top: 50%;
            transform: translateX(${props.translateX ? `${props.translateX}px` : '8px'}) translateY(-50%);
          `
        : css`
            top: 0;
            transform: translateX(${props.translateX ? `${props.translateX}px` : '8px'}) translateY(${props.translateY ? `${props.translateY}px` : '0px'});
          `}

      &:before {
        top: 50%;
        right: calc(100% + 1px);
        bottom: unset;
        left: unset;
        transform: translateY(-50%);
        border-bottom-color: transparent;
        border-right-color: var(--tooltip-border, ${props => props.theme?.tooltip?.border || props.theme.colors.shades.neutral[0]});
      }

      &:after {
        top: 50%;
        right: 100%;
        bottom: unset;
        left: unset;
        transform: translateY(-50%);
        border-bottom-color: transparent;
        border-right-color: var(--tooltip-bg, ${props => props.theme?.tooltip?.background || props.theme.colors.main.dark});
      }
    `}
`

export const TooltipContainer = styled('div')`
  position: relative;
  display: inline-flex;
  align-items: center;
  &:hover ${TooltipTextWrapper} {
    visibility: visible;
  }
`

export const TooltipText = styled(FontStyle).attrs({ as: 'h6', tag: 'h6' })`
  color: inherit;
  cursor: inherit;
`
